
import { defineComponent } from "vue";
import { getTimeThresholds, getTimeFailMessage } from "@/data/games";
import { mapGetters } from "vuex";
import { getTimeScoreColorClass } from "@/helper/scoreColorClass";

export default defineComponent({
  name: "TimeScoreView",

  data() {
    return {
      gameTimeThresholds: [] as number[],
      failMessage: "" as string,
      newBestTime: false,
    };
  },

  props: {
    time: {
      type: Number,
      required: true,
    },
    gameName: {
      type: String,
      required: true,
    },
  },

  created() {
    this.gameTimeThresholds = getTimeThresholds(this.gameName);
    this.failMessage = getTimeFailMessage(this.gameName);

    let currentHighscore = parseFloat(this.highscore);
    if (this.time > 0 && (!currentHighscore || this.time < currentHighscore)) {
      this.newBestTime = true;
      this.$store.dispatch("saveHighscore", this.time);
    }
  },

  computed: {
    ...mapGetters({ highscore: "getHighscore" }),
    scoreClass(): string {
      return getTimeScoreColorClass(this.time, this.gameTimeThresholds);
    },
    flickerClass(): string {
      if (this.time <= this.gameTimeThresholds[2] || this.time < 0) {
        return "flicker";
      }
      return "";
    },
    timeOrFailMessage(): number | string {
      return this.time > 0 ? this.time.toFixed(3) : this.failMessage;
    },
  },

  methods: {},
});
